const GLOBAL_MAILTO_SUPPORT_LINK = 'mailto:support@bloomfilter.app';
const DEFAULT_ROUTE = '/application/process-analysis';

export { DEFAULT_ROUTE, GLOBAL_MAILTO_SUPPORT_LINK };
